import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import './styles/common.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';

// 导入各个组件
import CategoryManager from './components/CategoryManager';
import ArticleEditor from './components/ArticleEditor';
import ArticleList from './components/ArticleList';
import ArticleDetail from './components/ArticleDetail';
import DraftBox from './components/DraftBox';
import TagManager from './components/TagManager';
import Analytics from './components/Analytics';
import Settings from './components/Settings';

const blogMenus = [
  { label: '分类管理', path: 'category' },
  { label: '内容创作', path: 'create' },
  { label: '内容列表', path: 'articles' },
  { label: '草稿箱', path: 'drafts' },
  { label: '标签管理', path: 'tags' },
  { label: '统计分析', path: 'analytics' },
  { label: '设置管理', path: 'settings' },
];

export default function Blog() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const activePath = pathParts[2] || blogMenus[0].path;
  const articleId = pathParts[3]; // 获取文章ID
  
  // 检查是否是文章详情页面
  const isArticleDetail = activePath === 'article' && articleId;
  const activeMenu = isArticleDetail ? null : (blogMenus.find(m => m.path === activePath) || blogMenus[0]);

  // 渲染博客内容
  const renderBlogContent = () => {
    if (isArticleDetail) {
      return <ArticleDetail />;
    }

    if (!activeMenu) return null;

    switch (activeMenu.path) {
      case 'category':
        return <CategoryManager />;
      case 'create':
        return <ArticleEditor mode="create" />;
      case 'articles':
        return <ArticleList />;
      case 'drafts':
        return <DraftBox />;
      case 'tags':
        return <TagManager />;
      case 'analytics':
        return <Analytics />;
      case 'settings':
        return <Settings />;
      default:
        return <div className="page_content_placeholder">这里是「{activeMenu.label}」的内容区域。</div>;
    }
  };

  return (
    <div className={`page_container ${isArticleDetail ? 'article-detail-view' : ''}`}>
      {/* 左侧菜单栏 - 文章详情页面时隐藏 */}
      {!isArticleDetail && (
        <div className="menu_sidebar">
          {blogMenus.map(menu => (
            <div
              key={menu.path}
              onClick={() => navigate(`/blog/${menu.path}`)}
              className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
            >
              {menu.label}
            </div>
          ))}
        </div>
      )}
      {/* 右侧内容区 */}
      <div className="page_content_area">
        {renderBlogContent()}
      </div>
    </div>
  );
} 